import RegisterLead from './RegisterLead';

export default RegisterLead;
